import React from 'react';
// import classnames from 'classnames';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import { ReactComponent as FavoriteSvg } from 'assets/svg/favorite-line.svg';
import { ReactComponent as NotificationSvg } from 'assets/svg/notification-line.svg';

export const EmptyContent = props => {
  // const [modal, setModal] = useState(false);

  return (
    <div className="thread__container">
      <div className="thread__card thread__card--empty thread__notification-svg">
        {props.recommendations ? (
          <>
            <FavoriteSvg height={78} width={53} />
            <p className="thread__text thread__text--subtitle">
              No recommendations yet
            </p>
          </>
        ) : null}
        {props.notification ? (
          <>
            <NotificationSvg height={78} width={53} />
            <p className="thread__text thread__text--subtitle">
              You don’t have any notifications yet
            </p>
          </>
        ) : null}
      </div>
    </div>
  );
};

EmptyContent.propTypes = {
  recommendations: PropTypes.bool,
  notification: PropTypes.bool
};
